import * as React from "react";
import { css } from "aphrodite";
import { StarRatingStyle } from "./StarRatingStyle";
import { StarStyle } from "main/javascripts/styles/fontStyle";

interface IProps extends React.AllHTMLAttributes<HTMLDivElement> {
  rating: number;
  styles?: any;
}

const getStarStyle: any = (rating: number): any => {
  const starVal: number = Math.floor(rating * 2) / 2;
  const starString = `star${starVal.toString().replace(".", "_")}`;

  return StarStyle[starString];
};

export const StarRating: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> | null => {
  const { rating, styles = {}, ...rest } = props;
  const { block, iconBlock } = styles;
  if (rating === 0) {
    return null;
  }
  return (
    <div className={css(StarRatingStyle.block, block)} {...rest}>
      <div className={css(StarRatingStyle.iconBlock, iconBlock)}>
        <div className={css(StarRatingStyle.starRating, StarStyle.starEmpty)} />
        <div
          className={css(
            StarRatingStyle.starRating,
            StarRatingStyle.starPositive,
            getStarStyle(rating)
          )}
        />
      </div>
    </div>
  );
};
